/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PreferenceReference } from './';
import {
    PreferenceReferenceFromJSON,
    PreferenceReferenceFromJSONTyped,
    PreferenceReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface Preference
 */
export interface Preference {
    /**
     * 
     * @type {string}
     * @memberof Preference
     */
    type: PreferenceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Preference
     */
    level: PreferenceLevelEnum;
    /**
     * 
     * @type {PreferenceReference}
     * @memberof Preference
     */
    value: PreferenceReference;
}


/**
 * @export
 */
export const PreferenceTypeEnum = {
    Duration: 'DURATION',
    ActivityArea: 'ACTIVITY_AREA',
    CompanySize: 'COMPANY_SIZE'
} as const;
export type PreferenceTypeEnum = typeof PreferenceTypeEnum[keyof typeof PreferenceTypeEnum];

/**
 * @export
 */
export const PreferenceLevelEnum = {
    Positive: 'POSITIVE',
    Negative: 'NEGATIVE'
} as const;
export type PreferenceLevelEnum = typeof PreferenceLevelEnum[keyof typeof PreferenceLevelEnum];


/**
 * Check if a given object implements the Preference interface.
 */
export function instanceOfPreference(value: object): value is Preference {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function PreferenceFromJSON(json: any): Preference {
    return PreferenceFromJSONTyped(json, false);
}

export function PreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Preference {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'level': json['level'],
        'value': PreferenceReferenceFromJSON(json['value']),
    };
}

export function PreferenceToJSON(value?: Preference | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'level': value['level'],
        'value': PreferenceReferenceToJSON(value['value']),
    };
}

